export const MuiSwitch = {
  styleOverrides: {
    root: {
      '.MuiButtonBase-root.Mui-checked': {
        color: 'rgba(30, 237, 159, 1)',

        '+.MuiSwitch-track': {
          background: 'rgba(30, 237, 159, 1)',
        },
      },
    },
    track: {
      background: 'rgba(159, 159, 159, 1)',
      opacity: 1,
    },
  },
};
